import {
  CURRENCY,
  INSTITUTIONS_PER_COLUMN,
  MAXIMUM_INSTITUTION_LENGTH,
} from "../../../../../utils/Constants";
import { Address } from "viem";
import { Charity } from "../../../../../models/Charity";
import { generateColor } from "../../../../../utils/Utils";

export interface CharityListProps {
  charities: Charity[];
  you?: Address;
  current?: Address;
  showTooltip?: boolean;
}

export default function CharityList(props: CharityListProps) {
  const charityColumns = Math.ceil(
    props.charities.length / INSTITUTIONS_PER_COLUMN,
  );
  return (
    <div
      className={`self-start grid grid-cols-${charityColumns} ~gap-y-1/2 ~gap-x-0.5/1`}
    >
      {props.charities.length > 0 ? (
        props.charities.map((charity, index) => (
          <div
            key={index}
            className="flex flex-row items-center"
            data-tooltip-id={props.showTooltip ? "default-tooltip" : undefined}
            data-tooltip-content={
              props.showTooltip
                ? charity.name +
                  ` (${charity.donationsReceived.pretty} ${CURRENCY})`
                : undefined
            }
          >
            <div
              className="w-2 h-2 rounded-full"
              style={{
                backgroundColor: generateColor(index / props.charities.length),
              }}
            ></div>
            <span className="font-archb font-bold ~text-xs/sm text-silver-light ~leading-2/3 ~ml-1/2">
              <span>
                {charity.name
                  ?.toUpperCase()
                  .substring(0, MAXIMUM_INSTITUTION_LENGTH)}
              </span>
              <span className="bg-gradient-to-b from-mango to-crail bg-clip-text text-transparent">
                {charity.address == props.current && (
                  <span>{" (CURRENT)"}</span>
                )}
                {charity.address == props.you && <span>{" (YOU)"}</span>}
              </span>
            </span>
          </div>
        ))
      ) : (
        <span className="font-archb ~text-xs/sm text-silver-light ~leading-2/3 ~ml-1/2">
          No Charities yet
        </span>
      )}
    </div>
  );
}
